module.exports = __webpack_public_path__ + "static/media/Dosis-Bold.77c62314.ttf";